import dashboardicon from "../assets/data-analysis.png";
import React, { useState, useEffect } from "react";
import Table1 from "./Table1";
import styles from "../components/tradeall.module.css";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import savedicon from "../assets/Bookmark.png";
import { DatePicker } from "antd";
import logout_eye_btn from "../assets/IBUTTON.png";
import refresh_icon from "../assets/refresh.png";
import today_img_icon from "../assets/today.png";
import today_img_icon_active from "../assets/today_active.png";
import Navbar from "./Navbar";
import filter_icon from "../assets/uil_calender.png";
import yesterday_img_icon from "../assets/yesterday.png";
import yesterday_img_icon_active from "../assets/active_yesterday.png";
import tomorrow_img_icon from "../assets/tomorrow.png";
import tomorrow_img_icon_active from "../assets/active_tomorrow.png";
import next7days_img_icon from "../assets/next_7_days.png";
import next7days_img_icon_active from "../assets/active_next_7_days.png";
import { DownOutlined } from "@ant-design/icons";
import { Select, Space } from "antd";
import last4months_img_icon from "../assets/4months.png";
import last4months_img_icon_active from "../assets/4months_active.png";

// <----mobile icon---->
import next7days_img_icon_active_m from "../assets/active_next_7_days_m.png";
import yesterday_img_icon_m from "../assets/yesterday_m.png";
import yesterday_img_icon_active_m from "../assets/active_yesterday_m.png";
import tomorrow_img_icon_m from "../assets/tomorrow_m.png";
import tomorrow_img_icon_active_m from "../assets/active_tomorrow_m.png";
import next7days_img_icon_m from "../assets/next_7_days_m.png";
import today_img_icon_m from "../assets/today_m.png";
import today_img_icon_active_m from "../assets/active_today_m.png";
import last4months_img_icon_m from "../assets/last_4_months_m.png";
import last4months_img_icon_active_m from "../assets/active_last_4_months_m.png";

const { RangePicker } = DatePicker;
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const countries = [
  "UK",
  "US",
  "CA",
  "CH",
  "EU",
  "JP",
  "AU",
  "NZ",
  "DE",
  "IT",
  "FR",
];

const EconomicsCalender = () => {
  const [clickedon, setclickedon] = useState("today");
  const [errorMessage, setErrorMessage] = useState("");
  const [maindata, setmaindata] = useState([]);
  // const [clickedend, setclickedend] = useState("todaydata");
  const [loading, setLoading] = useState(true);
  const [clickedButton, setClickedButton] = useState("Today");
  const [hideEstimate, setHideEstimate] = useState(false);
  // const [isReloadLoading, setIsReloadLoading] = useState(false);
  const [dateRange, setDateRange] = useState(null);
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [mobileStartDate, setMobileStartDate] = useState(null); // for mobile
  const [mobileEndDate, setMobileEndDate] = useState(null); // for mobile
  // const [selectedCountries, setSelectedCountries] = useState([]);
  const { Option } = Select;
  const [selectedImpacts, setSelectedImpacts] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState([]);

  const [isVisible, setIsVisible] = useState(false);

  const toggleVisibility = () => {
    setIsVisible((prev) => !prev);
  };

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setSelectedCountry(typeof value === "string" ? value.split(",") : value);
  };

  const handleadminpannel = () => {
    window.open("/admin/dashboard", "_blank");
  };

  const handleImpactChange = (values) => {
    setSelectedImpacts(values);
  };
  const handleCountryChange = (values) => {
    setSelectedCountry(values);
  };

  // <<-------for today , yesterday , tomorrow , and next week data on screen -------->>

  const handleTodayClick = async () => {
    // console.log("hi today api git hit")
    setLoading(true);

    const tokenfromls = localStorage.getItem("token");

    const h = { authorization: tokenfromls };
    const endpoint = `${process.env.REACT_APP_URL}/todaydata`;
    try {
      // console.log("hi today try")

      const response = await axios.get(endpoint, { headers: h });
      let filteredData = response.data;
      // console.log("filteredData" , filteredData)
      setClickedButton("Today");
      //  return;
      setmaindata(filteredData.uniqueEvents);
      setLoading(false);
      setIsVisible(false);
      setDateRange(null);
      setclickedon("today");
    } catch (error) {
      setLoading(false);
      setClickedButton("Today");

      setclickedon("today");

      if (error.response && error.response.status === 400) {
        setErrorMessage(errorMessage);
        setmaindata([]);
      } else {
        const errorMessage = "Error fetching data. Please try again later.";
        setErrorMessage(errorMessage);
      }
      console.error("Error fetching data:", error);
    }
  };
  const handleYesterdayClick = async () => {
    setLoading(true);
    const tokenfromls = localStorage.getItem("token");

    const h = { authorization: tokenfromls };
    const endpoint = `${process.env.REACT_APP_URL}/yesterdaydata`;
    try {
      const response1 = await axios.get(endpoint, { headers: h });

      let filteredData = response1.data;
      setClickedButton("Yesterday");
      setmaindata(filteredData.uniqueEvents);
      setLoading(false);
      setIsVisible(false);
      setDateRange(null);
      setclickedon("yesterday");
      // setclickedend("yesterdaydata");
    } catch (error) {
      setLoading(false);
      setClickedButton("Yesterday");

      setclickedon("yesterday");
      // setclickedend("yesterdaydata");

      if (error.response && error.response.status === 400) {
        setErrorMessage(errorMessage);
        setmaindata([]);
      } else {
        const errorMessage = "Error fetching data. Please try again later.";
        setErrorMessage(errorMessage);
      }
      console.error("Error fetching data:", error);
    }
  };
  const handleTomorrowClick = async () => {
    // console.log("hi am tomo clicked api")
    setLoading(true);
    setErrorMessage("");

    const tokenfromls = localStorage.getItem("token");

    const h = { authorization: tokenfromls };
    const endpoint = `${process.env.REACT_APP_URL}/tomorrowdata`;
    try {
      // console.log("hi am in try tomorrow")

      const response2 = await axios.get(endpoint, { headers: h });

      const filteredData = response2.data;
      // console.log("tom result---------------", filteredData)
      // return;
      setClickedButton("Tomorrow");
      setmaindata(filteredData.uniqueEvents);
      setLoading(false);
      setIsVisible(false);
      setclickedon("tomorrow");
      // setclickedend("tomorrowdata");
      setDateRange(null);
    } catch (error) {
      setLoading(false);
      setClickedButton("Tomorrow");
      setclickedon("tomorrow");
      // setclickedend("tomorrowdata");

      if (error.response && error.response.status === 400) {
        setErrorMessage(errorMessage);
        setmaindata([]);
      } else {
        const errorMessage = "Error fetching data. Please try again later.";
        setErrorMessage(errorMessage);
      }
      console.error("Error fetching data:", error);
    }
  };
  const handleweekClick = async () => {
    setLoading(true);
    const tokenfromls = localStorage.getItem("token");

    const h = { authorization: tokenfromls };
    // setclickedend("nextdaysdata");
    const endpoint = `${process.env.REACT_APP_URL}/nextdaysdata`;
    try {
      const response3 = await axios.get(endpoint, { headers: h });

      const flattenedData = response3.data.uniqueEvents;

      setClickedButton("Next7Days");

      setmaindata(flattenedData);

      setclickedon("nextdays");

      setLoading(false);
      setIsVisible(false);
      setDateRange(null);
    } catch (error) {
      setLoading(false);
      setClickedButton("Next7Days");
      setclickedon("nextdays");
      // setclickedend("nextdaysdata");

      if (error.response && error.response.status === 400) {
        setErrorMessage(errorMessage);
        setmaindata([]);
      } else {
        const errorMessage = "Error fetching data. Please try again later.";
        setErrorMessage(errorMessage);
      }
      console.error("Error fetching data:", error);
    }
  };
  const handlelast4monthsClick = async () => {
    // console.log("hi")
    setLoading(true);
    const tokenfromls = localStorage.getItem("token");

    const h = { authorization: tokenfromls };
    // setclickedend("nextdaysdata");
    const endpoint = `${process.env.REACT_APP_URL}/last4monthsdata`;
    try {
      const response3 = await axios.get(endpoint, { headers: h });
      // console.log("response3" , response3)
      // const flattenedData = Array.isArray(response3.data)
      //   ? response3.data.uniqueEvents.flatMap((innerArray) => innerArray)
      //   : [];
      const flattenedData = response3.data.uniqueEvents;
      // console.log("flattenedData" , flattenedData)
      setClickedButton("Last4months");
      // setmaindata(flattenedData);
      setmaindata(flattenedData);

      setclickedon("last4months");
      // setclickedend("nextdaysdata");
      setLoading(false);
      setIsVisible(false);
      setDateRange(null);
    } catch (error) {
      setLoading(false);
      setClickedButton("Last4months");
      setclickedon("last4months");
      // setclickedend("nextdaysdata");

      if (error.response && error.response.status === 400) {
        setErrorMessage(errorMessage);
        setmaindata([]);
      } else {
        const errorMessage = "Error fetching data. Please try again later.";
        setErrorMessage(errorMessage);
      }
      console.error("Error fetching data:", error);
    }
  };

  const handleRefresh = () => {
    // setIsReloadLoading(true);
    setLoading(false);
    // Loop through localStorage and remove any item with "Clickeddate_data_"
    Object.keys(localStorage).forEach((key) => {
      if (
        key.includes("Clickeddate_data_") ||
        key.includes("table3_historyData_") ||
        key.includes("clickedmodal_data_2ndpage_")
      ) {
        localStorage.removeItem(key);
      }
    });

    localStorage.removeItem("All_events_history");
    localStorage.removeItem("lastDeletionTime");
    localStorage.removeItem("UserId");
    localStorage.removeItem("userId");
    localStorage.removeItem("selectedtime");
    localStorage.removeItem("4GraphDataobjects");
    // localStorage.removeItem("userregisterId");
    // localStorage.removeItem("username");
    localStorage.removeItem("token");
    localStorage.removeItem("todayDate");
    localStorage.removeItem("previousDate_u_search_history");
    localStorage.removeItem("eventnameandcountry:");

    localStorage.removeItem("selectedtime");
    localStorage.removeItem("userEmail");
  };

  const [modalShow, setModalshow] = useState(false);

  const handleModalShowClick = () => {
    setModalshow(true);
  };
  useEffect(() => {
    handleTodayClick();
  }, []);

  // <----------impact and country filters---------->

  const handleDateChange = async (dates, dateStrings) => {
    setLoading(true);
    setDateRange(dates);
    // const tokenfromls = localStorage.getItem("token");
    // const h = { authorization: tokenfromls };
    const [startDate, endDate] = dateStrings;
    if (!dates) {
      setDateRange(null);
      // setmaindata();
      // setClickedButton("Today");
      handleTodayClick();
      setLoading(false);
      return;
    }
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/datepicker`,
        { startDate, endDate }
        // { headers: h }
      );
      // setDateRange(dates);
      // console.log("Dates---->" , startDate , "" , + "" , endDate)
      setmaindata(response.data);
      setClickedButton("");
      setclickedon("");
      //  setclickedend("");
      setLoading(false);

      // console.log("response.data" , response.data)
    } catch (error) {
      setClickedButton("");
      setclickedon("");
      //  setclickedend("");
      setLoading(false);
      const errorMessage =
        error.response && error.response.status === 400
          ? error.response.data.error
          : "Error fetching data. Please try again later.";
      setErrorMessage(errorMessage);
      console.error("Error fetching data:", error);
    }
    setDateRange(dates);
  };

  // <--------------toggle estimate fields on frontend------------>
  const handleEstimateToggle = () => {
    setHideEstimate(!hideEstimate);
  };

  const handlesaved_tradeoptions = () => {
    // navigate("/user/savedtradeOptions")
    window.open("/user/savedtradeOptions", "_blank");
  };

  const handletradepage = () => {
    window.open("/user/buysell", "_blank");
  };
  const handleResize = () => {
    const widthThreshold = 1500; // Set your desired width
    if (window.innerWidth <= widthThreshold) {
      setIsOpen(false);
    } else {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    // Run once on mount
    handleResize();

    // Add event listener for resizing
    window.addEventListener("resize", handleResize);

    // Cleanup listener on unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleOverlayClick = (e) => {
    // Close modal only if clicking outside the modal content
    if (e.target.id === "overlay") {
      setIsVisible(false);
    }
  };

  return (
    <div>
      <div>
        <div>
          <Navbar />
        </div>

        <div className="flex flex-row ">
          {/* <---sidebar---> */}
          <div
            className={`${
              styles.sidebar_class
            } fixed h-[100vh] hidden lg:block pt-[6%] transition-all duration-400  ease-in-out cursor-pointer  ${
              isOpen ? "min-w-[13%]" : "min-w-[5%]"
            } bg-[#b9d0fe]  p-4`}
          >
            <div
              className={`  ${styles.savedhistorybtn} mb-4 top-[12%] fixed top:0 flex flex-col items-center justify-center`}
              onClick={handleadminpannel}
            >
              <img
                src={dashboardicon}
                alt="dashboardicon"
                className={`h-[40px] w-[36px] `}
                title="Dashboard"
              />

              <h1 className="text-[14px] text-center font-bold  mt-1 break-words text-[#240d3a]">
                User <br />
                Management
              </h1>
            </div>

            {/* Sidebar Content */}
            <div className="mt-[21vh] ">
              <div
                className={`flex flex-col  ${
                  isOpen ? "items-start" : "items-center"
                }`}
              >
                {/* <---hlo---> */}

                <div
                  className={`relative px-0 mb-4 flex justify-start items-start flex-col`}
                >
                  <div className="flex justify-center items-center flex-col">
                    <div className="relative flex items-center justify-center text-center">
                      <div>
                        <span
                          className="ml-0 mt-[16%] flex align-center justify-center text-center"
                          onClick={handleYesterdayClick}
                        >
                          {clickedButton === "Yesterday" ? (
                            <img
                              src={yesterday_img_icon_active}
                              alt="today_img"
                              className="h-[45px] w-[44px]"
                            />
                          ) : (
                            <img
                              src={yesterday_img_icon}
                              alt="today_img"
                              className="h-[45px] w-[44px]"
                            />
                          )}
                        </span>
                        <button
                          type="button"
                          onClick={handleYesterdayClick}
                          className={`h-[40px] text-[14px] font-bold  inline-flex items-center justify-center w-full  pb-2   rounded-md transition-opacity duration-300  ${
                            clickedButton === "Yesterday"
                              ? " text-[#3B82F6]"
                              : " text-[#240d3a]"
                          }`}
                        >
                          Yesterday
                        </button>
                      </div>

                      {clickedButton === "Yesterday" && (
                        <div className=" absolute top-[37%] right-[-70%] transform -translate-y-1/2 w-0 h-0 border-t-[20.5px] border-b-[20.5px] border-l-[34px] border-transparent border-l-[#b9d0fe]"></div>
                      )}
                    </div>
                    <div className="relative flex items-center justify-center text-center">
                      <div>
                        <span
                          className="ml-0 mt-[16%] flex align-center justify-center text-center"
                          onClick={handleTodayClick}
                        >
                          {clickedButton === "Today" ? (
                            <img
                              src={today_img_icon_active}
                              alt="today_img"
                              className="h-[40px] w-[44px]"
                            />
                          ) : (
                            <img
                              src={today_img_icon}
                              alt="today_img"
                              className="h-[40px] w-[44px]"
                            />
                          )}
                        </span>
                        <button
                          type="button"
                          onClick={handleTodayClick}
                          className={`h-[40px] text-[14px]  font-bold inline-flex items-center justify-center w-full  pb-2    rounded-md transition-opacity duration-300  
                        ${
                          clickedButton === "Today"
                            ? " text-[#3B82F6]"
                            : " text-[#240d3a]"
                        }`}
                        >
                          Today
                        </button>
                        {clickedButton === "Today" && (
                          <div className=" absolute top-[35%] right-[-142%] transform -translate-y-1/2 w-0 h-0 border-t-[20.5px] border-b-[20.5px] border-l-[34px] border-transparent border-l-[#b9d0fe]"></div>
                        )}
                      </div>
                    </div>
                    <div className="relative flex items-center justify-center text-center">
                      <div>
                        <span
                          className="ml-0 mt-[16%] flex align-center justify-center text-center"
                          onClick={handleTomorrowClick}
                        >
                          {clickedButton === "Tomorrow" ? (
                            <img
                              src={tomorrow_img_icon_active}
                              alt="today_img"
                              className="h-[45px] w-[44px]"
                            />
                          ) : (
                            <img
                              src={tomorrow_img_icon}
                              alt="today_img"
                              className="h-[45px] w-[44px]"
                            />
                          )}
                        </span>
                        <button
                          type="button"
                          onClick={handleTomorrowClick}
                          className={`h-[40px]  text-[14px] inline-flex items-center justify-center w-full  pb-2  font-bold  rounded-md transition-opacity duration-300  ${
                            clickedButton === "Tomorrow"
                              ? " text-[#3B82F6]"
                              : " text-[#240d3a]"
                          }`}
                        >
                          Tomorrow
                        </button>
                        {clickedButton === "Tomorrow" && (
                          <div className=" absolute top-[37%] right-[-68%] transform -translate-y-1/2 w-0 h-0 border-t-[20.5px] border-b-[20.5px] border-l-[34px] border-transparent border-l-[#b9d0fe]"></div>
                        )}
                      </div>
                    </div>

                    <div className="relative flex items-center justify-center text-center">
                      <div>
                        <span
                          className="ml-0 mt-[16%] flex align-center justify-center text-center"
                          onClick={handleweekClick}
                        >
                          {clickedButton === "Next7Days" ? (
                            <img
                              src={next7days_img_icon_active}
                              alt="today_img"
                              className="h-[45px] w-[44px]"
                            />
                          ) : (
                            <img
                              src={next7days_img_icon}
                              alt="today_img"
                              className="h-[45px] w-[44px]"
                            />
                          )}
                        </span>
                        <button
                          type="button"
                          onClick={handleweekClick}
                          className={`h-[40px]  inline-flex text-[14px] items-center justify-center w-full  pb-2  font-bold  rounded-md transition-opacity duration-300  ${
                            clickedButton === "Next7Days"
                              ? " text-[#3B82F6] "
                              : " text-[#240d3a] "
                          }`}
                        >
                          Next 7 Days
                        </button>
                      </div>
                      {clickedButton === "Next7Days" && (
                        <div className=" absolute top-[39%] right-[-52%] transform -translate-y-1/2 w-0 h-0 border-t-[20.5px] border-b-[20.5px] border-l-[34px] border-transparent border-l-[#b9d0fe]"></div>
                      )}
                    </div>

                    <div className="relative flex items-center justify-center text-center">
                      <div>
                        <span
                          className="ml-0 mt-[16%] flex align-center justify-center text-center"
                          onClick={handlelast4monthsClick}
                        >
                          {clickedButton === "Last4months" ? (
                            <img
                              src={last4months_img_icon_active}
                              alt="last_4month_img"
                              className="h-[45px] w-[44px]"
                            />
                          ) : (
                            <img
                              src={last4months_img_icon}
                              alt="last_4month_img"
                              className="h-[45px] w-[44px]"
                            />
                          )}
                        </span>
                        <button
                          type="button"
                          onClick={handlelast4monthsClick}
                          className={`h-[40px]  inline-flex text-[14px] items-center justify-center w-full  pb-2  font-bold  rounded-md transition-opacity duration-300  ${
                            clickedButton === "Last4months"
                              ? " text-[#3B82F6] "
                              : " text-[#240d3a] "
                          }`}
                        >
                          Last 4 Months
                        </button>
                      </div>
                      {clickedButton === "Last4months" && (
                        <div className=" absolute top-[48%] right-[-41%] transform -translate-y-1/2 w-0 h-0 border-t-[20.5px] border-b-[20.5px] border-l-[34px] border-transparent border-l-[#b9d0fe]"></div>
                      )}
                    </div>

                    {/* <----last 4 months---> */}
                  </div>
                </div>
              </div>
            </div>

            {/* <------mobile view sidebar start ------> */}
          </div>

          {isVisible && (
            <div
              id="overlay"
              className="fixed inset-0 z-[998] bg-black bg-opacity-50 flex items-end"
              onClick={handleOverlayClick}
            >
              <div
                className={`p-2 z-[999] bg-white rounded-t-[20px] w-full h-[44%] flex flex-col justify-center relative transition-all duration-500 transform ease-out ${
                  isVisible ? "translate-y-0" : "translate-y-full"
                }`}
              >
                {/* Cross Button */}
                <button
                  className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
                  onClick={() => setIsVisible(false)}
                  aria-label="Close Modal"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="2"
                    stroke="currentColor"
                    className="w-6 h-6"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>

                <div className="flex  items-center justify-around w-full">
                  <div className="flex  items-center border-2 rounded-[14px] border-[#fff] py-3 px-2 w-[180px]  md:w-[230px] ">
                    {" "}
                    <span className="ml-2">
                      {clickedButton === "Yesterday" ? (
                        <img
                          src={yesterday_img_icon_active_m}
                          alt="today_img"
                          className="h-[40px] w-[65px]"
                        />
                      ) : (
                        <img
                          src={yesterday_img_icon_m}
                          alt="today_img"
                          className="h-[40px] w-[65px]"
                        />
                      )}
                    </span>
                    <button
                      type="button"
                      onClick={handleYesterdayClick}
                      className={`h-[40px] text-[16px] ml-2 inline-flex items-center justify-center w-full  py-2  font-medium  rounded-md transition-opacity duration-300  ${
                        clickedButton === "Yesterday"
                          ? " text-[#3B82F6]"
                          : " text-[#240d3a]"
                      }`}
                    >
                      Yesterday
                    </button>
                  </div>
                  <div className="flex  items-center border-2 rounded-[14px] border-[#fff] py-3 px-2 w-[180px]  md:w-[230px] ">
                    <span className="ml-2">
                      {clickedButton === "Today" ? (
                        <img
                          src={today_img_icon_active_m}
                          alt="today_img"
                          className="h-[37px] w-[71px]"
                        />
                      ) : (
                        <img
                          src={today_img_icon_m}
                          alt="today_img"
                          className="h-[37px] w-[71px]"
                        />
                      )}
                    </span>

                    <button
                      type="button"
                      onClick={handleTodayClick}
                      className={`h-[40px] text-[16px] ml-5 font-bold inline-flex items-center w-full  py-2   rounded-md transition-opacity duration-300  
                        ${
                          clickedButton === "Today"
                            ? " text-[#3B82F6]"
                            : " text-[#240d3a]"
                        }`}
                    >
                      Today
                    </button>
                  </div>
                </div>
                <div className="mt-6 flex  items-center justify-around w-full">
                  <div className="flex  items-center border-2 rounded-[14px] border-[#fff] py-3 px-2 w-[180px]  md:w-[230px] ">
                    <span className="ml-2">
                      {clickedButton === "Tomorrow" ? (
                        <img
                          src={tomorrow_img_icon_active_m}
                          alt="today_img"
                          className="h-[40px] w-[65px]"
                        />
                      ) : (
                        <img
                          src={tomorrow_img_icon_m}
                          alt="today_img"
                          className="h-[40px] w-[65px]"
                        />
                      )}
                    </span>
                    <button
                      type="button"
                      onClick={handleTomorrowClick}
                      className={`h-[40px] ml-2 text-[16px] inline-flex items-center justify-center w-full  py-2  font-medium  rounded-md transition-opacity duration-300  ${
                        clickedButton === "Tomorrow"
                          ? " text-[#3B82F6]"
                          : " text-[#240d3a]"
                      }`}
                    >
                      Tomorrow
                    </button>
                  </div>
                  <div className="flex  items-center border-2 rounded-[14px] border-[#fff] py-3 px-2 w-[180px]  md:w-[230px] ">
                    <span className="ml-2">
                      {clickedButton === "Next7Days" ? (
                        <img
                          src={next7days_img_icon_active_m}
                          alt="today_img"
                          className="h-[40px] w-[65px]"
                        />
                      ) : (
                        <img
                          src={next7days_img_icon_m}
                          alt="today_img"
                          className="h-[40px] w-[65px]"
                        />
                      )}
                    </span>
                    <button
                      type="button"
                      onClick={handleweekClick}
                      className={`h-[40px] ml-2 inline-flex text-[16px] items-center justify-center w-full  py-2  font-medium  rounded-md transition-opacity duration-300  ${
                        clickedButton === "Next7Days"
                          ? " text-[#3B82F6] "
                          : " text-[#240d3a] "
                      }`}
                    >
                      Next 7 Days
                    </button>
                  </div>
                </div>
                {/* <----4 months---> */}
                <div
                  className="w-full flex justify-center items-center"
                  onClick={handlelast4monthsClick}
                >
                  <div className=" mt-6 flex justify-center items-center text-center border-2 rounded-[14px] border-[#fff] py-3 px-2 ">
                    <span className="ml-2">
                      {clickedButton === "Last4months" ? (
                        <img
                          src={last4months_img_icon_active_m}
                          alt="last4months"
                          className="h-[40px] w-[65px]"
                        />
                      ) : (
                        <img
                          src={last4months_img_icon_m}
                          alt="last4months"
                          className="h-[40px] w-[65px]"
                        />
                      )}
                    </span>
                    <button
                      type="button"
                      onClick={handlelast4monthsClick}
                      className={`h-[40px] ml-2 inline-flex text-[16px] items-center justify-center w-full  py-2  font-medium  rounded-md transition-opacity duration-300  ${
                        clickedButton === "Last4months"
                          ? " text-[#3B82F6] "
                          : " text-[#240d3a] "
                      }`}
                    >
                      Last 4 Months
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* <------mobile view sidebar end ------> */}

          {/* <----main componnet render----> */}
          <div
            className={` transition-all duration-200  ease-in-out 
              " ml-[9%] w-[93%]"
           `}
          >
            <div className="">
              <div
                className={`fixed top-[10%] ${isOpen ? "w-[80%]" : "w-[89%]"}`}
              >
                <div className=" z-[999] w-[100%]   ">
                  <div
                    className={`  ${styles.economiccalender} ml:0 sm:ml-0 md:ml-0  lg:ml-[6%] xl:ml-0 mt-[8%] sm:mt-[9%] md:mt-0 lg:mt-0 xl:mt-0 buttons flex flex-col  items-start  justify-start`}
                  >
                    <div className="flex justify-between w-full">
                      <h1
                        className={`  ${styles.economiccalender_h1}   font-bold text-[22px] sm:text-[22px] md:text-[32px] lg:text-[32px] xl:text-[32px]  text-[#240D3A] mt-4`}
                      >
                        Economic Calendar
                      </h1>

                      <div className="flex">
                        <button
                          className="hidden max-[1023px]:block mt-2"
                          onClick={handleadminpannel}
                        >
                          <img
                            src={dashboardicon}
                            alt="dashboard icon"
                            className={`h-7 w-6 cursor-pointer   `}
                          />
                        </button>
                        <button
                          className="ml-2 hidden max-[1023px]:block "
                          onClick={toggleVisibility}
                        >
                          <img
                            src={filter_icon}
                            alt="filter icon"
                            className={`h-[24px] w-[24px] cursor-pointer   `}
                          />
                        </button>
                      </div>
                    </div>
                    <div
                      className={` ${styles.saved_haeder6} w-full first-div flex flex-col sm:flex-col md:flex-col lg:flex-col xl:flex-row mt-[1%] justify-between`}
                    >
                      <div className=" flex flex-col sm:flex-col md:flex-col lg:flex-row xl:flex-row">
                        <div className="relative block sm:block md:inline-block lg:inline-block xl:inline-block pr-3  mb-5 sm:mb-5 md:mb-5 lg:mb-0 xl:mb-0 z-[999] bg-[#F6F6F6]">
                          <Space
                            style={{ width: "100%" }}
                            direction="vertical"
                            className="z-[999] border-[#240d3a] "
                          >
                            <Select
                              mode="multiple"
                              allowClear
                              style={{
                                width: "270px",
                                height: "46px",
                                maxHeight: "46px",
                                backgroundColor: "#F6F6F6", // Grey background
                                border: "1px solid #240d3a", // Light grey border
                                borderRadius: "4px",
                              }}
                              placeholder={
                                <span
                                  style={{ color: "#240d3a", fontSize: "16px" }}
                                >
                                  Country
                                </span>
                              }
                              onChange={handleCountryChange}
                              getPopupContainer={(triggerNode) => document.body}
                              className="z-[999] custom-select overflow-visible"
                              dropdownStyle={{
                                maxHeight: "800px",
                                overflowY: "auto", // Adds vertical scrollbar for dropdown options
                              }}
                              suffixIcon={
                                <DownOutlined
                                  style={{
                                    fontSize: "14px",
                                    color: "#240d3a", // Change icon color here
                                  }}
                                />
                              }
                              maxTagCount={1} // Only show one country in the select box
                              maxTagTextLength={20} // Adjust max length if necessary
                            >
                              <Option value="AU">Australia (AU)</Option>
                              <Option value="CA">Canada (CA)</Option>
                              <Option value="EU">Europe (EU)</Option>
                              <Option value="FR">France (FR)</Option>
                              <Option value="DE">Germany (DE)</Option>
                              <Option value="IT">Italy (IT)</Option>
                              <Option value="JP">Japan (JP)</Option>
                              <Option value="NZ">New Zealand (NZ)</Option>
                              <Option value="CH">Switzerland (CH)</Option>
                              <Option value="UK">United Kingdom (UK)</Option>
                              <Option value="US">United States (US)</Option>
                            </Select>
                          </Space>
                        </div>
                        <div className="relative inline-block px-0 sm:px-0 md:px-0 lg:px-3 xl:px-3">
                          <Space
                            style={{ width: "100%" }}
                            direction="vertical"
                            className="z-[999] border-[#240d3a] "
                          >
                            <Select
                              mode="multiple"
                              allowClear
                              style={{
                                width: "270px",
                                height: "46px",
                                maxHeight: "46px",
                                backgroundColor: "#F6F6F6", // Grey background
                                border: "1px solid #240d3a", // Light grey border
                                borderRadius: "4px",
                              }}
                              placeholder={
                                <span
                                  style={{ color: "#240d3a", fontSize: "16px" }}
                                >
                                  Impact
                                </span>
                              }
                              onChange={handleImpactChange}
                              // getPopupContainer={(trigger) => trigger.parentNode}
                              getPopupContainer={(triggerNode) => document.body}
                              className="z-[999] custom-select overflow-visible"
                              dropdownStyle={{
                                maxHeight: "800px",
                                overflowY: "auto", // Adds vertical scrollbar for dropdown options
                              }}
                              suffixIcon={
                                <DownOutlined
                                  style={{
                                    fontSize: "14px",
                                    color: "#240d3a", // Change icon color here
                                  }}
                                />
                              }
                              maxTagCount={3} // Only show one country in the select box
                              maxTagTextLength={20} // Adjust max length if necessary
                            >
                              <Option value="High">High</Option>
                              <Option value="Medium">Medium</Option>
                              <Option value="Low">Low</Option>
                            </Select>
                          </Space>
                        </div>

                        <div
                          className={` ${styles.rangepicker}  range-picker items-center  text-center flex mt-4 sm:mt-4 md:mt-4 lg:mt-[-4px] xl:mt-[-4px] ml-[-24px] sm:ml-[-24px] md:ml-[-2%] lg:ml-0 xl:ml-0 pl-6 md:pl-3 w-[30vw] sm:w-[30vw] md:w-full `}
                          style={{ height: "56px" }}
                        >
                          <Space direction="vertical" size={16}>
                            {/* <RangePicker onChange={handleDateChange}/> */}
                            <RangePicker
                              value={dateRange}
                              onChange={(dates, dateStrings) =>
                                handleDateChange(dates, dateStrings)
                              }
                              className="hidden sm:hidden md:block text-[16px] h-[48px] w-[270px] lg:w-full border-[#240d3a] border active:outline-none bg-[#F6F6F6] focus:outline-none  rounded-md placeholder-[#240d3a] custom-rangepicker "
                            />


                          </Space>
                          <div className="flex gap-2 flex-col md:hidden">
    <DatePicker
      value={mobileStartDate}
      onChange={(date, dateString) => {
        setMobileStartDate(date);
        if (date && mobileEndDate) {
          handleDateChange(
            [date, mobileEndDate],
            [dateString, mobileEndDate.format("YYYY-MM-DD")]
          );
          setDateRange([date, mobileEndDate]); // sync with desktop range
        }
      }}
    />
    <DatePicker
      value={mobileEndDate}
      onChange={(date, dateString) => {
        setMobileEndDate(date);
        if (mobileStartDate && date) {
          handleDateChange(
            [mobileStartDate, date],
            [mobileStartDate.format("YYYY-MM-DD"), dateString]
          );
          setDateRange([mobileStartDate, date]); // sync with desktop range
        }
      }}
    />
  </div>
                        </div>
                      </div>

                      <div className="flex mt-[10px] sm:mt-[10px] md:mt-[8px] lg:mt-0 xl:mt-0 ml-[-9px] sm:ml-[-9px] md:ml-[-9px] lg:ml-0 xl:ml-0">
                        <div className="relative mt-2 sm:mt-2 md:mt-2 lg:mt-2 xl:mt-0 inline-block  px-[10px] sm:px-[10px] md:px-1 lg:px-1 xl:px-3">
                          <button
                            type="button"
                            onClick={handleEstimateToggle}
                            className={`h-[46px] inline-flex items-center justify-center w-full px-4 py-2  font-medium text-[#240d3a] border rounded-md focus:outline-none focus-visible:ring border-[#240d3a] `}
                          >
                            {hideEstimate
                              ? "Show All Estimate"
                              : "Hide Empty Estimate"}
                          </button>
                        </div>

                        <div>
                          <img
                            src={refresh_icon}
                            alt="Refresh"
                            title="Refresh"
                            className={`h-[40px] w-[40px] cursor-pointer mt-3 sm:mt-3 md:mt-3 lg:mt-3 xl:mt-0 ml-2`}
                            onClick={handleModalShowClick}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className={` fixed overflow-auto `}>
              <Table1
                clickedon={clickedon}
                maindata={maindata}
                hideEstimate={hideEstimate}
                selectedCountry={selectedCountry}
                selectedImpacts={selectedImpacts}
                isOpen={isOpen}
              />
            </div>
          </div>
        </div>
      </div>

      <div>
        {modalShow && (
          <div
            id="popup-modal"
            className="fixed top-0 right-0 bottom-0 left-0 flex justify-center items-center bg-black bg-opacity-15 z-50"
            onClick={() => setModalshow(!modalShow)}
          >
            <div className="relative p-4 w-full max-w-md">
              <div className="relative bg-white rounded-lg shadow">
                <img
                  src={logout_eye_btn}
                  alt="logout_eye_btn"
                  className="h-[33px] w-[33px] absolute top-[12%] left-[47%]"
                />
                <div className="p-4 md:p-5 text-center">
                  <h3 className="mb-5 mt-[15%] text-lg font-bold text-[240D3A]">
                    Are you sure you want to refresh the page? This action will
                    clear all locally stored data.
                  </h3>
                  <div className="flex items-center justify-center">
                    <button
                      data-modal-hide="popup-modal"
                      type="button"
                      className="text-[#240D3A]  bg-[#ecebeb] mt-3 font-medium rounded-lg  inline-flex items-center justify-center px-3 py-2 w-[20%]"
                      onClick={handleRefresh}
                    >
                      Yes
                    </button>
                    <button
                      data-modal-hide="popup-modal"
                      type="button"
                      className="ml-4 text-white  bg-[#240D3A] mt-3 font-medium rounded-lg  inline-flex items-center justify-center px-3 py-2 w-[20%]"
                      onClick={() => setModalshow(!modalShow)}
                    >
                      No
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default EconomicsCalender;
